import { Company, EntityKind, Site } from 'app2/api';

export interface TimeTrackingProps {
  entity?:Partial<Site | Company>;
}

export function getOwner(props:TimeTrackingProps) {
  const entity = props.entity;
  return {ownerType: (entity as any)?.__typename?.toUpperCase() as EntityKind, ownerId: entity?.id}
}